import React, { useState } from 'react';

import FilterBox from './components/FilterBox';
import ChoosenFilters from './components/ChoosenFilters';

import { Container, Item } from './styles';

const Filters = ({
  selectedFilters,
  setSelectedFilters,
  filters,
  setFilters,
}) => {
  const [showFilter, setShowFilter] = useState(false);
  const [filterOptions, setFilterOptions] = useState([]);
  const [lastFilterName, setLastFilterName] = useState('');

  function handleOnClick(filterClass, filtersOptions) {
    setFilterOptions(filtersOptions);
    if (filterClass !== lastFilterName) {
      setLastFilterName(filterClass);
      setShowFilter(true);
    } else if (filterClass === lastFilterName) {
      setLastFilterName('');
      setShowFilter(false);
    }
  }

  if (!filters) {
    return (
      <Container className="filters">
        <p>Carregando....</p>;
      </Container>
    );
  }

  return (
    <Container className="filters">
      {filters.map((filter) => {
        return (
          <Item
            onClick={() => handleOnClick(filter.name, filter.filters)}
            key={filter.name}
          >
            {filter.name}
          </Item>
        );
      })}

      <FilterBox
        showFilter={showFilter}
        filterOptions={filterOptions}
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
      />
      <ChoosenFilters
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
      />
    </Container>
  );
};

export default Filters;
